var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-btn',{attrs:{"color":"orange","small":"","dark":"","disabled":!_vm.product.inventory},on:{"click":function($event){return _vm.addToCart(_vm.product)}}},[_vm._v(" Ajouter ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }